import { Component } from '@angular/core';
import moment from 'moment';
import { ReportService } from 'src/app/reports/services/report.service';
import { POCReportService } from '../../poc-report/poc-report.component.service';
import { ActivatedRoute } from '@angular/router';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { ReportsChartEnum } from 'src/app/reports/models/enums/reports.enum';

@Component({
  selector: 'app-total-land-property',
  templateUrl: './total-land-property.component.html',
  styleUrls: ['./total-land-property.component.scss']
})
export class TotalLandPropertyComponent {
  loader: boolean = false;
  overViewSummary: any;
  routeSub$: Subscription = new Subscription();
  chartView = ReportsChartEnum;

  constructor(private reportService: ReportService,
    private pocReportService: POCReportService,
    private activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.routeSub$ = this.activatedRoute.queryParams.pipe(
      distinctUntilChanged(),
    ).subscribe((params) => {
      this.getOverviewSummary();
    })
   
  }


  getOverviewSummary() {
    this.loader = true;
    this.pocReportService.getTotalLandProperty().subscribe(
      {
        next: (res: any) => {
          if (res.status === 200) {
            this.overViewSummary = this.formatOverViewSummary(res.data)
          } else {
            this.overViewSummary = null;
          }
          this.loader = false;
        },
        error: (error: any) => {
          this.overViewSummary = null;
          this.loader = false;
        }
      }
    )
  }


  formatOverViewSummary(data: any) {
    data['total_percentage'] = this.reportService.calcPercentage(data.total_land_prev, data.total_land_current);
    data['untillDate'] = data.max_date_current ? moment.utc(data.max_date_current).local().format('DD MMM YYYY') : null;
    return data;
  }

  ngOnDestroy(): void {
    this.routeSub$?.unsubscribe();
  }
}
